var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimeBack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "78px",
    viewBox: "0 0 92 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeBack",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92,39 C92,60.5 74.6,78 53.2,78 C45.3,78 37.7,75.6 31.2,71.2 C29.4,69.9 28.9,67.5 30.2,65.6 C31.5,63.8 33.9,63.3 35.8,64.6 C40.9,68.1 47,70 53.2,70 C70.2,70 84,56.1 84,39 C84,21.9 70.2,8 53.2,8 C36.6,8 23,21.3 22.4,37.9 L31.7,28.5 C33.3,26.9 35.8,26.9 37.4,28.5 C39,30.1 39,32.6 37.4,34.2 L22.1,49.5 C21.3,50.3 20.3,50.7 19.3,50.7 C18.2,50.7 17.2,50.3 16.5,49.5 L1.2,34.1 C-0.4,32.5 -0.4,30 1.2,28.4 C2.8,26.8 5.3,26.8 6.9,28.4 L14.5,36.1 C15.9,16 32.7,0 53.2,0 C74.6,0 92,17.5 92,39 Z M53,16.3 C50.8,16.3 49,18.1 49,20.3 L49,39 C49,40.1 49.5,41.1 50.3,41.8 L58.9,50.4 C59.7,51.2 60.7,51.6 61.8,51.6 C62.8,51.6 63.9,51.2 64.6,50.4 C66.2,48.8 66.1,46.3 64.5,44.7 L57,37.3 L57,20.3 C57,18.1 55.2,16.3 53,16.3 Z",
    id: "Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/timeBack.2afb19084d26362d16f521a8dbaac00d.svg";